export function getCurrentDate() {
  return new Date();
}

export function getDateString(date) {
  return date.toISOString().split('T')[0];
}

export function getEndDate() {
  let date = new Date();
  date.setMonth(date.getMonth() + 3);
  date.setDate(0);

  return date;
}
